import React from "react"
import Strings from "utils/strings"
import { FLEET_MAP_COLORS } from "utils/fleetMapConfig"
import {
	legendContainerStyle,
	legendItemStyle,
	legendSectionTitleStyle,
} from "../styles"

const MapLegend: React.FC = () => {
	const markerItems = [
		{
			color: FLEET_MAP_COLORS.markerSuccess,
			label: Strings.routes.fleetTracking.legendSuccess,
		},
		{
			color: FLEET_MAP_COLORS.markerFailed,
			label: Strings.routes.fleetTracking.legendFailed,
		},
		{
			color: FLEET_MAP_COLORS.markerInTransit,
			label: Strings.routes.fleetTracking.legendInTransit,
		},
		{
			color: FLEET_MAP_COLORS.markerEnroute,
			label: Strings.routes.fleetTracking.legendEnroute,
		},
		{
			color: FLEET_MAP_COLORS.markerArrived,
			label: Strings.routes.fleetTracking.legendArrived,
		},
		{
			color: FLEET_MAP_COLORS.markerOutcome,
			label: Strings.routes.fleetTracking.legendOutcomeLocation,
		},
	]

	const routeItems = [
		{
			color: FLEET_MAP_COLORS.routeTaken,
			label: Strings.routes.fleetTracking.legendRouteCompleted,
		},
		{
			color: FLEET_MAP_COLORS.routeActive,
			label: Strings.routes.fleetTracking.legendRouteActive,
		},
		{
			color: FLEET_MAP_COLORS.routeRemaining,
			label: Strings.routes.fleetTracking.legendRouteRemaining,
		},
	]

	return (
		<div style={legendContainerStyle}>
			<div>
				<span style={legendSectionTitleStyle}>
					{Strings.routes.fleetTracking.legendMarkers}
				</span>
				<div
					style={{ display: "flex", flexWrap: "wrap", gap: 14, marginTop: 4 }}
				>
					{markerItems.map((item) => (
						<div key={item.color} style={legendItemStyle}>
							<span
								style={{
									width: 10,
									height: 10,
									borderRadius: "50%",
									backgroundColor: item.color,
									display: "inline-block",
								}}
							/>
							<span>{item.label}</span>
						</div>
					))}
				</div>
			</div>
			<div>
				<span style={legendSectionTitleStyle}>
					{Strings.routes.fleetTracking.legendRoutes}
				</span>
				<div
					style={{ display: "flex", flexWrap: "wrap", gap: 14, marginTop: 4 }}
				>
					{routeItems.map((item) => (
						<div key={item.color} style={legendItemStyle}>
							<span
								style={{
									width: 20,
									height: 4,
									borderRadius: 2,
									backgroundColor: item.color,
									display: "inline-block",
								}}
							/>
							<span>{item.label}</span>
						</div>
					))}
				</div>
			</div>
		</div>
	)
}

export default MapLegend
